import { Card, CardContent, Typography } from '@mui/material';

interface StatTileProps {
  label: string;
  value: number | string;
  color?: string;
}

export const StatTile = ({ label, value, color }: StatTileProps) => (
  <Card variant="outlined" sx={{ minWidth: 160, flex: '1 1 160px' }}>
    <CardContent>
      <Typography variant="h4" sx={{ color: color ?? 'text.primary', fontWeight: 600 }}>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </CardContent>
  </Card>
);
